import axios from "axios";
import React from "react";

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    let RIError = {};
    try {
      if (error.response && error.response.data) {
        if (typeof error.response.data === "string") {
          RIError = JSON.parse(error.response.data);
        } else {
          RIError = error.response.data;
        }
        RIError.status = error.response.status;
      } else {
        // Fallback for network errors or other issues
        RIError.message = error.message || String(error);
        RIError.error = error.request?.statusText || "Network Error";
        RIError.status = error.request?.status || 0;
      }
    } catch (e) {
      RIError.message = error.message || String(error);
      RIError.error = "Unexpected Error";
      RIError.status = 0;
    }
    
    console.error('API Error:', RIError);
    return Promise.reject(RIError);
  }
);

const serverUrl = "/account-management";
const endpoints = {
  registerPolicyholderValidate: serverUrl + "/ripolicy/policyholder/validate",
  registerPolicyholderRegister: serverUrl + "/ri-rest-services/api/public/registerInsuredUser",
  policyholderAlreadyExists: serverUrl + "/ri-rest-services/api/public/policyholderAlreadyExists",
  policyholderAlreadyRegistered: serverUrl + "/ri-rest-services/api/public/policyholderAlreadyRegistered",
  policyholderAuthCode: serverUrl + "/ri-rest-services/api/public/policyholderAuthCode", //FB 21511
  userIdAlreadyExists: serverUrl + "/ri-rest-services/api/public/userIdAlreadyExists",
  forgotPassword: serverUrl + "/ri-rest-services/api/public/ph/forgotPassword",
  forgotUsername: serverUrl + "/ri-rest-services/api/public/ph/forgotUsername"
};

const ValidateAccessToken = params => {
  return axios
    .get(endpoints.registerPolicyholderValidate, {
      params: params || {}
    })
    .then(res => res.data);
};

const RegisterPolicyHolder = data => {
  return axios
    .post(endpoints.registerPolicyholderRegister, data, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(res => res.data);
};

const PolicyholderAlreadyExists = params => {
  return axios
    .get(endpoints.policyholderAlreadyExists, {
      params: params || {}
    })
    .then(res => res.data);
};

const PolicyholderAlreadyRegistered = params => {
  return axios
    .get(endpoints.policyholderAlreadyRegistered, {
      params: params || {}
    })
    .then(res => res.data);
};
//FB 21511 ------------
const PolicyholderAuthCode = params => {
  return axios
    .get(endpoints.policyholderAuthCode, {
      params: params || {}
    })
    .then(res => res.data);
};
// ------------ FB 21511
const UserIdAlreadyExists = params => {
  return axios
    .get(endpoints.userIdAlreadyExists, {
      params: params || {}
    })
    .then(res => res.data);
};

const ForgotPassword = data => {
  return axios
    .post(endpoints.forgotPassword, data, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(res => res.data);
};

const ForgotUsername = data => {
  return axios
    .post(endpoints.forgotUsername, data, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(res => res.data);
};
export {
  ValidateAccessToken,
  RegisterPolicyHolder,
  PolicyholderAlreadyExists,
  PolicyholderAlreadyRegistered,
  UserIdAlreadyExists,
  ForgotPassword,
  ForgotUsername,
  PolicyholderAuthCode
};
